import { defineMessages } from 'react-intl'
export default defineMessages({
  addBtn:{id: 'app.components.AddressDropdown.addBtn'},
  header:{id: 'app.components.CalculatorModal.header'},
  storePrice: { id: 'app.components.CalculatorModal.storePrice' },
  itemWeight: { id: 'app.components.CalculatorModal.itemWeight'},
  weightKG: { id: 'app.components.CalculatorModal.weightKG'},
  weightGram: { id: 'app.components.CalculatorModal.weightGram'},
  couponCode: { id: 'app.components.CalculatorModal.couponCode'},
  category: { id: 'app.components.CalculatorModal.category'},
  quantity: { id: 'app.components.CalculatorModal.quantity'},
  subscription: { id: 'app.components.CalculatorModal.subscription'},
  addItemButtonText: { id: 'app.components.CalculatorModal.addItemButtonText'},
  pickForMe: { id: 'app.components.CalculatorModal.pickForMe' },
  current: { id: 'app.components.CalculatorModal.current' },
  itemsTotal: { id: 'app.components.CalculatorModal.itemsTotal' },
  itemsTotalPrice: { id: 'app.components.CalculatorModal.itemsTotalPrice' },
  itemsTotalWeight: { id: 'app.components.CalculatorModal.itemsTotalWeight' },
  shopText: { id: 'app.components.CalculatorModal.shopText' },
  serviceFees: { id: 'app.components.CalculatorModal.fees' },
  subtotal: { id: 'app.components.CalculatorModal.subtotal' },
  total: { id: 'app.components.CalculatorModal.total' },
  shipText: { id: 'app.components.CalculatorModal.shipText' },
  customs: { id: 'app.components.CalculatorModal.customs' },
  vat: { id: 'app.components.CalculatorModal.vat' },
  clearance: { id: 'app.components.CalculatorModal.clearance' },
  clearanceHint: { id: 'app.components.CalculatorModal.clearanceHint' },
  intlShipping: { id: 'app.components.CalculatorModal.intlShipping' },
  deliveryFee: { id: 'app.components.CalculatorModal.deliveryFee' },
  discount: { id: 'app.components.CalculatorModal.discount' },
  grandTotal: { id: 'app.components.CalculatorModal.grandTotal' },
  exchange: { id: 'app.components.CalculatorModal.exchange' },
  totalCur: { id: 'app.components.CalculatorModal.totalCur' },
  approxDesclaimer: {id: 'app.components.CalculatorModal.approxDesclaimer'},
  calculate: {id: 'app.components.CalculatorModal.calculate'},
  calculateAnotherItem: {id: 'app.components.CalculatorModal.calculateAnotherItem'},
  serviceFeesHint: {id: 'app.containers.Ship.LockerPage.serviceFeesHint'},
  useCode: {id: 'app.components.CalculatorModal.useCode'},
  useCodePromo: {id: 'app.components.CalculatorModal.useCodePromo'},
  exchangeRate: {id: 'app.containers.Shop.CartPage.TotalAndCheckout.exchangeRate'},
  placeOrder: {id: 'app.components.CalculatorModal.placeOrder'},
})


// WEBPACK FOOTER //
// ./app/components/CalculatorModal/messages.js